import { useState } from 'react'
import { useLogin } from '../api/hooks'
import { ApiError } from '../api/client'

export default function Login() {
  const [password, setPassword] = useState('')
  const [err, setErr] = useState<string | null>(null)
  const login = useLogin()

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    setErr(null)
    login.mutate(password, {
      onError: (e) => setErr(e instanceof ApiError ? e.detail : 'Erreur'),
    })
  }

  return (
    <div className="min-h-screen relative flex items-center justify-center p-4">
      {/* Hero background */}
      <div className="absolute inset-0">
        <picture>
          <source media="(min-width: 1024px)" srcSet="/hero-large.jpg" />
          <source media="(min-width: 640px)" srcSet="/hero-medium.jpg" />
          <img
            src="/hero-small.jpg"
            alt=""
            className="w-full h-full object-cover object-[center_35%]"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-br from-ocean-900/70 via-ocean-800/60 to-coral-900/40" />
      </div>

      <form
        onSubmit={submit}
        className="relative card shadow-card p-7 sm:p-9 w-full max-w-sm anim-in"
      >
        <div className="text-center mb-6">
          <div className="text-5xl mb-2">🏖️</div>
          <h1 className="text-2xl font-display font-bold text-ocean-900">Etchehoun</h1>
          <p className="text-sm text-ocean-700 font-medium">Séjour familial Hossegor 2026</p>
        </div>

        <label className="label" htmlFor="pwd">Mot de passe partagé</label>
        <input
          id="pwd"
          type="password"
          autoFocus
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input mb-3"
          placeholder="••••••••"
        />
        {err && (
          <div className="text-coral-700 bg-coral-50 border border-coral-200 rounded-lg px-3 py-2 text-sm mb-3 anim-in">
            {err}
          </div>
        )}
        <button
          type="submit"
          disabled={login.isPending || password.length === 0}
          className="btn-primary w-full"
        >
          {login.isPending ? 'Connexion…' : 'Se connecter'}
        </button>

        <p className="text-[11px] text-ocean-600/80 text-center mt-5">
          Le mot de passe est partagé par la famille.
        </p>
      </form>
    </div>
  )
}
